<template>
  <av-media
    class="waveform"
    :media="stream"
    :frequ-lnum="lineNum"
    type="frequ"
    :canv-width="waveWidth"
    :canv-height="waveHeight"
    line-color="#1287cd"
    :line-width="lineWidth"
    :frequ-line-cap="lineCap"
  />
</template>

<script>
export default {
  props: ['stream'],
  data() {
    return {
      lineNum: 3,
      lineWidth: 6,
      lineCap: true,
      waveHeight: 24,
      waveWidth: 30
    };
  }
};
</script>